// Real Digitalbeej conversion & contact endpoints.

const WHATSAPP_NUMBER = "918928864286"; // +91 89288 64286
const WHATSAPP_DEFAULT_MESSAGE =
    "Hi Digitalbeej, I'd like to discuss a project.";

// UTM tags appended to every WhatsApp CTA for campaign attribution.
const WHATSAPP_UTM =
    "utm_source=website&utm_medium=cta&utm_campaign=digitalbeej_site";

export const WHATSAPP_HREF = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_DEFAULT_MESSAGE,
)}&${WHATSAPP_UTM}`;

// Discovery-call scheduler — placeholder until a Cal.com / Calendly link is provided.
export const DISCOVERY_CALL_HREF = "https://cal.com/digitalbeej/discovery";

export const STUDIO_EMAIL = "abhay@digitalbeej.in";
export const EMAIL_HREF = `mailto:${STUDIO_EMAIL}`;

export const SOCIALS = {
    instagram: "https://www.instagram.com/digitalbeej",
    linkedin: "https://www.linkedin.com/company/14421908",
    facebook: "https://www.facebook.com/DigitalBeejIndia/",
};
